module.exports = __webpack_public_path__ + "static/img/code.ddfe42d4.png";